<template>
    <div>
        <h1>솔닥 의료 마이데이터 민감정보 수집·이용 동의</h1>
        주식회사 솔닥(이하 “회사”라 합니다)은 개인정보보호법 시행령 제42조의9에 따른 특수전문기관으로서 정보주체의 전송요구권 행사에 따라 보건의료정보전송자로부터 회원의 보건의료정보를 수신할 수 있습니다.<br>
        회사는 개인정보보호법 제35조의2 제1항 제1호에 근거하여 회원의 개인정보 전송요구권 행사에 따른 정보주체의 보건의료정보 제공(의료 마이데이터 연동 및 건강정보 조회 서비스)을 위하여 아래와 같이 회원의 민감정보를 수집·이용합니다.<br>
        회원은 아래 내용을 자세히 확인한 후 동의 여부를 결정할 수 있습니다.<br>
        본 동의는 솔닥 의료 마이데이터 서비스 제공을 위해 필요한 필수 동의입니다. 동의하지 않을 경우 의료 마이데이터 연동, 건강정보 조회, 연동기관 관리 등 관련 서비스를 이용할 수 없습니다.<br>
        구체적인 의료 마이데이터 전송요구에 관한 사항은 회원이 마이데이터 연동 과정에서 별도 전송요구 화면을 통해 직접 선택·확인하는 내용에 따릅니다.<br>
        <h3>1. 개인정보 수집·이용 목적</h3>
        회원의 개인정보 전송요구권 행사에 따른 솔닥 의료 마이데이터 서비스 내 건강정보 통합조회, 회원 식별, 계정 연계, 마이데이터 연동 관리 및 맞춤형 건강관리 서비스 제공<br>
        <h3>2. 수집·이용 및 전송을 요구하는 민감정보 항목</h3>
        회사는 의료 마이데이터 연동 및 건강정보 조회를 위해 아래 민감정보를 수집·이용하거나 보건의료정보전송자로부터 전송받을 수 있습니다.<br>
        ① 건강보험심사평가원 보유 정보<br>
        투약이력, 의약품명, 투약일자, 투약기간, 처방기관, 조제기관, 기타 투약이력 조회를 위해 필요한 정보<br>
        ② 국민건강보험공단 보유 정보<br>
        건강검진정보, 암검진정보, 검진일자, 검진기관, 검진 항목, 검진 결과(검진 종류, 검진 연도, 검진 일자, 기관명, 종합판정, 의심 질환, 유질환, 생활습관 관리, 기타, 체중, 키, 허리둘레, 시력, 청력(좌/우), 성별, 나이, 체질량지수(BMI), 혈압(최고/최저), 공복 혈당, 총 콜레스테롤, HDL콜레스테롤, LDL콜레스테롤, AST(SGOT), ALT(SGPT), 감마지티피(y-GTP), 흉부촬영, 혈청크레아티닌, 신사구체여과율(GFR), 요단백, 혈색소, 골다공증, 위험 구분 등), 판정 및 소견, 기타 건강검진 및 암검진 조회를 위해 필요한 정보<br>
        ③ 질병관리청 보유 정보<br>
        예방접종 이력, 백신명, 접종일자, 접종차수, 접종기관, 기타 예방접종 이력 조회를 위해 필요한 정보<br>
        ④ 의료기관 보유 정보<br>
        진료이력, 진단내역, 처방내역, 약물처방정보, 수술 및 처치내역, 진단검사 결과, 기타검사 결과, 영상검사 결과, 병리검사 결과, 알레르기 및 불내성 정보, 부작용 정보, 내원정보, 진료기록요약지, 기타 회원이 전송요구한 의료기관 보유 건강정보<br>
        ※ 회사가 실제로 수집·이용하거나 전송받는 민감정보 항목은 회원이 선택한 연동기관, 전송요구 항목, 보건의료정보전송자의 제공 범위 및 관계 법령에 따라 달라질 수 있습니다.<br>
        <h3>3. 민감정보의 보유 및 이용기간</h3>
        마이데이터 서비스 이용기간 동안 보유하며, 마이데이터 서비스 이용 철회 또는 솔닥 회원 탈퇴 시 즉시 파기합니다. 단, 개인정보보호법 시행령 제42조의6 제9항에 의해 보관해야 하는 전송내역은 3년간 보관됩니다.<br><br>
        회원은 본 개인정보 수집·이용 및 전송요구에 대한 동의를 거부할 수 있습니다.<br>
        다만, 본 동의는 솔닥 의료 마이데이터 서비스 제공을 위해 필요한 필수 동의이므로, 동의하지 않을 경우 의료 마이데이터 연동, 건강정보 조회, 연동기관 관리 등 관련 서비스 이용이 제한될 수 있습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataSensitiveCollection'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/SensitiveCollection.vue